import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalizationPipe } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { UserService } from 'src/core/services/user/user.service';
@Component({
  selector: 'app-ai-disclaimer-modal',
  standalone: true,
  imports: [LocalizationPipe, CommonModule],
  templateUrl: './ai-disclaimer-modal.component.html',
  styleUrl: './ai-disclaimer-modal.component.scss',
})
export class AiDisclaimerModalComponent {
  constructor(public activeModal: NgbActiveModal, private userService: UserService) {}
  ngOnInit(): void {}

  close(): void {
    this.userService.setConfirmedAiUsageDisclaimer().subscribe(() => {
      this.activeModal.close();
    });
  }
}
